import gql from 'graphql-tag';

export default gql`
  mutation joinChannel($channelId: UUID!) {
    joinChannel(channelId: $channelId) {
      _id
    }
  }
`;
